import { format as n } from "../util.mjs";
var h = function(e, l, F, s, u) {
  var g = typeof e.len == "number", t = typeof e.min == "number", i = typeof e.max == "number", o = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, r = l, m = null, y = typeof l == "number", p = typeof l == "string", f = Array.isArray(l);
  if (y ? m = "number" : p ? m = "string" : f && (m = "array"), !m)
    return !1;
  f && (r = l.length), p && (r = l.replace(o, "_").length), g ? r !== e.len && s.push(n(u.messages[m].len, e.fullField, e.len)) : t && !i && r < e.min ? s.push(n(u.messages[m].min, e.fullField, e.min)) : i && !t && r > e.max ? s.push(n(u.messages[m].max, e.fullField, e.max)) : t && i && (r < e.min || r > e.max) && s.push(n(u.messages[m].range, e.fullField, e.min, e.max));
};
export {
  h as default
};
//# sourceMappingURL=range.mjs.map
